import { RoleEnumValue } from './RoleEnum';

export const ProjectStatusEnumValue = {
  OnGoing: 10,
  PendingApproval: 20,
  Signed: 30,
  Shipped: 40,
  Delivered: 50,
  Completed: 100,
  Cancelled: 200,
};

export const ProjectStatusEnum = [
  {
    value: ProjectStatusEnumValue.OnGoing,
    name: 'OnGoing',
    labelFrench: 'En cours',
    labelEnglish: 'On going',
    labelFrenchAction: 'En cours',
    labelEnglishAction: 'On going',
    availableStatuses: [
      {
        statuses: [ProjectStatusEnumValue.PendingApproval, ProjectStatusEnumValue.Cancelled],
      },
    ],
    roles: [RoleEnumValue.Administrator, RoleEnumValue.User],
  },
  {
    value: ProjectStatusEnumValue.PendingApproval,
    name: 'PendingApproval',
    labelFrench: 'En attente de validation',
    labelEnglish: 'Pending Approval',
    labelFrenchAction: 'Envoyer',
    labelEnglishAction: 'Send',
    availableStatuses: [
      {
        statuses: [ProjectStatusEnumValue.Signed, ProjectStatusEnumValue.Cancelled],
      },
    ],
    roles: [RoleEnumValue.Administrator, RoleEnumValue.User],
  },
  {
    value: ProjectStatusEnumValue.Signed,
    name: 'Signed',
    labelFrench: 'Signé',
    labelEnglish: 'Signed',
    labelFrenchAction: 'Signé',
    labelEnglishAction: 'Signed',
    availableStatuses: [
      {
        statuses: [ProjectStatusEnumValue.Shipped, ProjectStatusEnumValue.Cancelled],
      },
    ],
    roles: [RoleEnumValue.Administrator],
  },
  {
    value: ProjectStatusEnumValue.Shipped,
    name: 'Shipped',
    labelFrench: 'Expédié',
    labelEnglish: 'Shipped',
    labelFrenchAction: 'Expédié',
    labelEnglishAction: 'Shipped',
    availableStatuses: [
      {
        statuses: [ProjectStatusEnumValue.Delivered, ProjectStatusEnumValue.Cancelled],
      },
    ],
    roles: [RoleEnumValue.Administrator],
  },
  {
    value: ProjectStatusEnumValue.Delivered,
    name: 'Delivered',
    labelFrench: 'Livré',
    labelEnglish: 'Delivered',
    labelFrenchAction: 'Livré',
    labelEnglishAction: 'Delivered',
    availableStatuses: [
      {
        statuses: [ProjectStatusEnumValue.Completed, ProjectStatusEnumValue.Cancelled],
      },
    ],
    roles: [RoleEnumValue.Administrator, RoleEnumValue.User],
  },
  {
    value: ProjectStatusEnumValue.Completed,
    name: 'Completed',
    labelFrench: 'Complété',
    labelEnglish: 'Completed',
    labelFrenchAction: 'Compléter',
    labelEnglishAction: 'Complete',
    availableStatuses: [],
    roles: [RoleEnumValue.Administrator, RoleEnumValue.User],
  },
  {
    value: ProjectStatusEnumValue.Cancelled,
    name: 'Cancelled',
    labelFrench: 'Annulé',
    labelEnglish: 'Cancelled',
    labelFrenchAction: 'Annuler',
    labelEnglishAction: 'Cancel',
    availableStatuses: [],
    roles: [RoleEnumValue.Administrator, RoleEnumValue.User],
  },
];

export default ProjectStatusEnum;
